/* ============ DR. KALE REMEDIES · CART DRAWER (JS) ============
   Uses Shopify's AJAX Cart API (/cart.js, /cart/add.js, /cart/change.js).
   Edit CFG below, or override any key before this file loads:
     <script>window.DK_CART_CONFIG = { banner: '...' }</script>                    */
(function () {
  'use strict';

  var CFG = {
    banner: 'Don\u2019t miss out: 50% OFF limited-time sale',
    upsellCollection: 'bestseller',        // fallback collection for "You might also like"
    gelNote: '',                           // optional strip above total, e.g. 'Free gift on orders above \u20B95,000'
    /* Reward stages, amounts in RUPEES, in ascending order.
       type: 'ship' | 'gift' | 'off'
       gift  -> variantId: a Shopify variant priced \u20B90 (see README note). 0 = show only, no auto-add.
       off   -> code: a Shopify discount code, applied at checkout via /checkout?discount=CODE */
    tiers: [
      { at: 1499,  type: 'ship', label: 'Free shipping' },
      { at: 4999,  type: 'off',  label: '5% off',  code: '' },
      { at: 9999,  type: 'off',  label: '10% off', code: '' },
      { at: 14999, type: 'off',  label: '15% off', code: '' },
      { at: 19999, type: 'off',  label: '20% off', code: '' }
    ],
    /* Prepaid offer (display + optional auto-applied code). Create a matching discount in Shopify. */
    prepaid: { enabled: true, steps: [{ min: 0, pct: 5 }, { min: 1999, pct: 10 }], code: '' },
    countSelectors: '[data-cart-count],.cart-count,#CartCount'
  };
  Object.assign(CFG, window.DK_CART_CONFIG || {});

  var R = CFG.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var root = document.documentElement;
  var el = {}, S = { cart: null, handles: {}, up: null, exp: false, busy: false, syncing: false };


  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(p) { var r = p / 100, d = p % 100 ? 2 : 0; return '\u20B9' + r.toLocaleString('en-IN', { minimumFractionDigits: d, maximumFractionDigits: d }); }
  function rs(n) { return fmt(n * 100); }
  function api(url, body) {
    var o = { headers: { 'Accept': 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; });
    });
  }
  function isGift(i) { return !!(i.properties && i.properties._free_gift); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  function toPaise(v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v; }
  function toast(m) { el.toast.textContent = m; el.toast.classList.add('show'); clearTimeout(toast.t); toast.t = setTimeout(function () { el.toast.classList.remove('show'); }, 3200); }
  function compareAt(i) {
    var p = S.handles[i.handle], v = p && p.variants && p.variants.filter(function (x) { return x.id === i.variant_id; })[0];
    return Math.max((v && v.compare_at_price) || 0, i.original_price);
  }

  /* ---------- icons ---------- */
  var IC = {
    check: '<path d="M13 23l5 5 10-11"/>',
    gift: '<rect x="11" y="21" width="18" height="11" rx="1.5"/><path d="M20 21v11M10 16h20v5H10zM20 16c-3-6-9-4-6 0M20 16c3-6 9-4 6 0"/>',
    ship: '<path d="M9 18h13v11H9zM22 22h5l3 3v4H22z"/><circle cx="14" cy="30" r="2"/><circle cx="26" cy="30" r="2"/>',
    off: '<path d="M14.5 29.5l11-11"/><circle cx="15.5" cy="19.5" r="2.2"/><circle cx="24.5" cy="28.5" r="2.2"/>'
  };
  var SVG = {
    chev: '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>',
    arrow: '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    lock: '<svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="9.5" rx="2"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5"/></svg>',
    next: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>',
    trash: '<svg viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    tag: '<svg viewBox="0 0 24 24" style="fill:currentColor;stroke:none"><path d="M12 2l2.4 1.8 3-.1.9 2.9 2.4 1.8-.9 2.9.9 2.9-2.4 1.8-.9 2.9-3-.1L12 22l-2.4-1.8-3 .1-.9-2.9-2.4-1.8.9-2.9-.9-2.9 2.4-1.8.9-2.9 3 .1z"/><path d="M9 9l6 6M9.5 9.5h.01M14.5 14.5h.01" style="stroke:#fff;stroke-width:2"/></svg>',
    truck: '<svg viewBox="0 0 40 40"><path d="M7 12h17v15H7zM24 17h6l4 5v5H24z"/><circle cx="13" cy="28" r="2.5"/><circle cx="29" cy="28" r="2.5"/></svg>',
    tick: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24"><path d="M6 8h12l1 12H5L6 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>'
  };

  /* payment icons on the Checkout button (UPI, card, net banking) */
  var PAY = {
    upi: '<svg viewBox="0 0 24 24" class="pi"><path d="M10.2 4.5 6 19.5h2.6l4.2-15z" fill="#097939" stroke="none"/><path d="M14.4 4.5 10.2 19.5h2.6l4.2-15z" fill="#ed752e" stroke="none"/><path d="M17.2 9.2 19.6 12l-2.4 2.8" fill="none" stroke="#097939" stroke-width="1.6"/></svg>',
    card: '<svg viewBox="0 0 24 24" class="pi"><rect x="3" y="6" width="18" height="12" rx="2.2" fill="none" stroke="#1c1f1d" stroke-width="1.7"/><path d="M3 10h18" stroke="#1c1f1d" stroke-width="2.4"/><path d="M6.5 14.5h4" stroke="#1c1f1d" stroke-width="1.7"/></svg>',
    bank: '<svg viewBox="0 0 24 24" class="pi"><path d="M3.5 9 12 4.5 20.5 9z" fill="none" stroke="#1c1f1d" stroke-width="1.7" stroke-linejoin="round"/><path d="M6 11v5.5M10 11v5.5M14 11v5.5M18 11v5.5M3.5 19h17" stroke="#1c1f1d" stroke-width="1.7"/></svg>'
  };

  /* PhonePe / Google Pay / Paytm logos, embedded (64px WebP) so nothing has to be uploaded */
  var LOGOS = [
    { alt: 'PhonePe', src: 'data:image/webp;base64,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' },
    { alt: 'Google Pay', src: 'data:image/webp;base64,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' },
    { alt: 'Paytm', src: 'data:image/webp;base64,UklGRkIFAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSMQBAAABCjnatql6MjOZnGgdqlzpcbYAS3BYgcsSQuurIDVauS7AodMq2v8yc5Bfz4u07ztfRDByJKkNjclwSjN+AkcgRJLVvoNX731crSUZy9WD+ypHxsAG8OZYHbjxaqMewsYrY+UY/dilCcelC69zLaUuMyWJTEZJ+fWFJccyXiF4t7D8uVbudKkh0Aqlz8sLzo8zKbI686VWJ2lEWCQ7U7k4xrA9D/pL4xQe2KijfHAnNutO1piwaNNcGCWKvFyrowYokpFhhPXnV+puViPQtFKGLu9Zbg0c1sAom/ccshpvqqUGoYofvFjkZXXUKEXGOPA7MaC3wU4bEAO3b6SGP4lpw/oW93HmSd1V45g4E3vGGE+qCECR9TR5bvueEyIwF/N0nOAldQXBRFcY/GJPDsoWfYjuYm8/pvsijZNvfueo7M2k4/6UBYPJHG/g6lKRcfqFurhgelH2bglZke09oiQg1JHLyLpkunwfndgnZI9EfVpFB9N/H/wQ/EL4fYs/N/hzi7838PcW/N78A+5t/LuBf7fw7yb83cbrBrhuwesmuG6D60a4bsXrZrhuh/sGuG+B+ya4b0P7RrhvhfvmP823w/8bEFZQOCBYAwAAkBQAnQEqQABAAD49GolDoiGhGAkGACADxLEAPE75v+LvOmbW97sl75ffsH23ZAD+Af5XoY/6B7APyA9WbrGP1g9gD9YPTJ/YD4K/2z9IC7L/oHQu+KPZLJ2/Zvyez4e8EcP/k/9u0W7Ux/3Dl1/OP/N9wn+Q/1H/go3Q92AZBZKNAwHl8/BzTTyM3vVmHdud2+c0yBzuVTVOGhjf9x5MLG1UP81tecIrl1YZEeAA/vtTf//nIf//OKT//84Civ//h/ATlHGkSbn9rcf/6Y3th8+A7LcxhgoIAmxSH8r2Y3W3ErKsvZFOTbqnR2p/YSSuw7JYjf0xM5+3/QT/l1+633f/7EAMKprqDPZuPcCP79i8xFwuiw7P3crD+23/PsGl3S3Z/8kf6TKezYai3ypQDimPjF+JeJwKbcrhYjTS/6zc/BAhCDNZP8EEsbzUekPHRX4uWxCw0Tl4Ipz+SVbKDvjPGSrX86pcv+8D570jPfeRovy8/HT44xrrASHc0FR4u8X7+NPH5HuzPc8gXeZ5QvHVbuI7Tq9s1VQ7258ALm/u2/5nyyK+1cEI+qgFu+FlsOlzt7QsFU8ItRBU0Uzg+YUL44WcSpBHu0dX/tVwAZ8GeHrpohfUTQzxV/43/Qw4yrUkTXlNwLGJT0xCC5VV5S93/gs2OrGEkL0G3NG3hh1uMVfEMKNgtbtucXB/yANoDQuFZ2ZY+qzhf3tMLandKAee9/9cbgffBu5jnWrLfjs+EH8Mm7/Iq7/8aVj/7Z3pU0BvzWNKtdPDBtwsR9UlbZCo+//8WDNn8f3/5V5Dus4kSVQdT7hulUwgIXmMmz5R8G/7MLynWvb06Hea4tb6Rf8O0myplIJ/jGjT3cPc9qe4bR+fj2dL5n0vO+xceMYICB5i2T7uX6MZf/jfhSGkmLX/TdxRKtjZsArTM95aHytj7KZoJIIt91ryrw8Sj8C2r/nYR/Ygtb+rFes9/1pkulKr7ZOvrNuDgBO8RuJCXUe8iwhOK4wShzUgAQe7kleO6HRJ48RxRCv73VCj9ikmnvjJLxn9NViX0U833l0sFud/CfXvuz2MEeMPlhSDBih522/Bd7VDl2PEyGKB831JVR1XYG8oW9sgID//8TWlIzAi///t/YAAAA==' }
  ];

  /* ---------- calculations ---------- */
  /* All money values come from Shopify's cart (/cart.js), so every discount Shopify applies
     (automatic discounts + valid discount codes on the cart) is reflected here.
       sub   = cart value used for reward stages (selling price, before coupon/automatic discounts)
       mrp   = sum of compare-at (MRP) prices
       total = Shopify's final cart total after all discounts                                   */
  function calc() {
    var c = S.cart, sub = 0, mrp = 0, offers = {};
    c.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) {
        var t = (d.discount_application && d.discount_application.title) || 'Discount';
        offers[t] = (offers[t] || 0) + d.amount;
      });
      if (isGift(i)) return;
      sub += i.original_line_price; mrp += compareAt(i) * i.quantity;
    });
    (c.cart_level_discount_applications || []).forEach(function (d) {
      var a = d.discount_application || d; // /cart.js and /cart/update.js return slightly different shapes
      var t = a.title || d.title || 'Discount';
      var amt = d.total_allocated_amount || a.total_allocated_amount || d.amount || 0;
      offers[t] = (offers[t] || 0) + amt;
    });
    var giftValue = 0; c.items.forEach(function (i) { if (isGift(i)) giftValue += i.original_line_price; });
    var off = [];
    Object.keys(offers).forEach(function (t) {
      var a = offers[t];
      if (giftValue && a === giftValue) return; // hide the 100%-off line used to make a gift free
      if (a > 0) off.push({ title: t, amount: a });
    });
    var total = c.total_price;
    mrp = Math.max(mrp, sub);
    var pp = 0;
    if (CFG.prepaid.enabled) CFG.prepaid.steps.forEach(function (s) { if (total / 100 >= s.min) pp = s.pct; });
    var saved = Math.max(0, mrp - total);
    return { sub: sub, mrp: mrp, total: total, prodDisc: Math.max(0, mrp - sub), offers: off, saved: saved,
      pct: mrp > total ? Math.round(saved / mrp * 100) : 0, pp: pp, ppSave: Math.round(total * pp / 10000) * 100 };
  }

  /* ---------- discount codes on the cart (validated by Shopify) ---------- */
  function cartCodes() { return (S.cart.discount_codes || []).map(function (d) { return d.code.toUpperCase(); }); }
  function codeApplicable(code) {
    return (S.cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
  }
  function tierCodes() { return CFG.tiers.filter(function (t) { return t.code; }).map(function (t) { return t.code.toUpperCase(); }); }
  function setCodes(list) {
    var uniq = list.filter(function (c, i) { return c && list.indexOf(c) === i; });
    return api(R + 'cart/update.js', { discount: uniq.join(',') });
  }
  /* Add each stage code when its cart value is reached, remove it when the cart drops below.
     Codes the shopper added (or that came from a discount link) are left untouched. */
  function syncCodes() {
    var managed = tierCodes(); if (!managed.length) return Promise.resolve(false);
    var sub = 0; S.cart.items.forEach(function (i) { if (!isGift(i)) sub += i.original_line_price; });
    var want = CFG.tiers.filter(function (t) { return t.code && sub / 100 >= t.at; }).map(function (t) { return t.code.toUpperCase(); });
    var have = cartCodes();
    var next = have.filter(function (c) { return managed.indexOf(c) < 0; }).concat(want);
    var same = next.length === have.length && next.every(function (c) { return have.indexOf(c) > -1; });
    if (same) return Promise.resolve(false);
    return setCodes(next).then(function () { return true; }).catch(function () { return false; });
  }

  /* ---------- render ---------- */
  function stepsHTML(k) {
    var T = CFG.tiers, n = T.length, v = k.sub / 100, next = null, i;
    for (i = 0; i < n; i++) if (v < T[i].at) { next = T[i]; break; }
    var msg = !next ? '\uD83C\uDF89 Congratulations! You\u2019ve unlocked all rewards' :
      next.type === 'ship' ? 'Add <b>' + rs(next.at - v) + '</b> more for <b>FREE shipping</b>' :
      next.type === 'gift' ? 'Add <b>' + rs(next.at - v) + '</b> more to get <b>' + (/^free/i.test(next.name || '') ? '' : 'a FREE ') + esc(next.name || 'gift') + '</b>' :
      'Add <b>' + rs(next.at - v) + '</b> more to get <b>' + esc(next.label) + '</b>';
    var last = null; for (i = 0; i < n; i++) if (v >= T[i].at && T[i].type === 'off') last = T[i];
    if (last && next) msg = '<b>' + esc(last.label) + '</b> unlocked \u2713 \u00B7 ' + msg;
    var c = function (j) { return (j + 0.5) / n * 100; }, w;
    if (v < T[0].at) w = c(0) * (v / T[0].at);
    else { w = c(n - 1); for (i = 0; i < n - 1; i++) if (v < T[i + 1].at) { w = c(i) + (c(i + 1) - c(i)) * (v - T[i].at) / (T[i + 1].at - T[i].at); break; } }
    if (!next) w = 100;
    var first = S.prevOk === undefined, prev = first ? T.length : S.prevOk, ok = 0;
    var html = '<div class="dk-rw"><div class="dk-steps"><div class="dk-track"><i style="width:' + w.toFixed(1) + '%"></i></div>' +
      T.map(function (t, j) {
        var done = v >= t.at; if (done) ok++;
        return '<div class="dk-st' + (done ? ' ok' : '') + (done && j >= prev ? ' pop' : '') + '"><small>' + rs(t.at) + '</small>' +
          '<span class="dk-dotc"><svg viewBox="8 12 24 24">' + (done ? IC.check : IC[t.type]) + '</svg></span>' +
          '<span class="dk-lb">' + esc(t.type === 'gift' && t.name ? t.name : t.label) + '</span></div>';
      }).join('') + '</div><div class="dk-msg">' + msg + '</div></div>';
    S.prevOk = ok;
    return html;
  }
  function itemHTML(i) {
    var g = isGift(i), cmp = compareAt(i), free = g || i.final_price === 0;
    var pr = free ? '<div class="dk-pr free">' + (cmp > 0 ? '<s>' + fmt(cmp * i.quantity) + '</s>' : '') + '<b>FREE</b></div>' :
      '<div class="dk-pr">' + (cmp > i.final_price ? '<s>' + fmt(cmp * i.quantity) + '</s>' : '') + '<b>' + fmt(i.final_line_price) + '</b></div>';
    var minus = i.quantity < 2
      ? '<button class="dk-qb dk-del" data-rm="' + esc(i.key) + '" aria-label="Remove ' + esc(i.product_title) + '">' + SVG.trash + '</button>'
      : '<button class="dk-qb" data-q="' + esc(i.key) + '" data-d="-1" aria-label="Decrease quantity">\u2212</button>';
    var ctl = g ? '<span class="dk-tag">Free gift \u00D7 ' + i.quantity + '</span>' :
      minus + '<span class="dk-qn">' + i.quantity + '</span><button class="dk-qb" data-q="' + esc(i.key) + '" data-d="1" aria-label="Increase quantity">+</button>';
    var vt = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
    return '<div class="dk-li" data-key="' + esc(i.key) + '"><a class="dk-im" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 200)) + '" alt="' + esc(i.product_title) + '" loading="lazy" decoding="async" width="84" height="84">' : '') +
      (g ? '<span class="dk-gift"><svg viewBox="8 12 24 24">' + IC.gift + '</svg></span>' : '') + '</a>' +
      '<div class="dk-inf"><a class="dk-nm" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + (vt ? '<div class="dk-vr">' + esc(vt) + '</div>' : '') +
      '<div class="dk-ctl"><div class="dk-q">' + ctl + '</div>' + pr + '</div></div></div>';
  }
  function upsellHTML() {
    if (S.up === null) return '<div class="dk-up"><h3>You might also like</h3><div class="dk-sk"></div></div>';
    if (!S.up.length) return '';
    return '<div class="dk-up"><h3>You might also like</h3><div class="dk-row" id="dk-row">' + S.up.map(function (p) {
      var multi = p.variants.length > 1, cmp = p.cmp > p.price ? '<s>' + fmt(p.cmp) + '</s>' : '';
      return '<div class="dk-uc"><a class="t" href="' + esc(p.url) + '"><img src="' + esc(img(p.img, 160)) + '" alt="" loading="lazy"><div><div class="n">' + esc(p.title) + '</div><div class="p">' + fmt(p.price) + cmp + '</div></div></a>' +
        (multi ? '<a class="a" href="' + esc(p.url) + '">Choose options</a>' : '<button class="a" data-add="' + p.vid + '">Add to cart</button>') + '</div>';
    }).join('') + '</div><button class="dk-nx" id="dk-nx" aria-label="Next products">' + SVG.next + '</button></div>';
  }
  function footHTML(k) {
    var c = S.cart; if (!c.items.length) return '';
    var pe = CFG.prepaid.enabled, lo = CFG.prepaid.steps[0], hi = CFG.prepaid.steps[CFG.prepaid.steps.length - 1];
    var freeShip = CFG.tiers.filter(function (t) { return t.type === 'ship'; })[0], shipOk = !freeShip || k.sub / 100 >= freeShip.at;
    var offerRows = k.offers.map(function (o) {
      return '<div><dt>' + esc(o.title) + '</dt><dd class="g">\u2212 ' + fmt(o.amount) + '</dd></div>';
    }).join('');
    var perks = [];
    perks.push(SVG.truck + (shipOk ? 'Free shipping' : 'Free shipping above ' + rs(freeShip.at)));
    if (pe && k.ppSave) perks.push(SVG.tick + 'Save ' + fmt(k.ppSave) + ' more on prepaid');
    return (CFG.gelNote ? '<div class="dk-gel">' + esc(CFG.gelNote) + '</div>' : '') +
      (k.saved > 0 ? '<div class="dk-rib">You\u2019re saving <b>' + fmt(k.saved) + '</b> on this order' + (k.pct ? ' (' + k.pct + '% off)' : '') + '</div>' : '') +
      '<div class="dk-det' + (S.exp ? ' open' : '') + '"><div><dl><div><dt>Total MRP</dt><dd>' + fmt(k.mrp) + '</dd></div>' +
      (k.prodDisc > 0 ? '<div><dt>Product discount</dt><dd class="g">\u2212 ' + fmt(k.prodDisc) + '</dd></div>' : '') +
      offerRows +
      '<div><dt>Shipping</dt><dd' + (shipOk ? ' class="g"' : '') + '>' + (shipOk ? 'FREE' : 'At checkout') + '</dd></div>' +
      '<div class="tot"><dt>Estimated total</dt><dd>' + fmt(k.total) + '</dd></div></dl></div></div>' +
      '<div class="dk-bar"><div class="dk-sum"><div class="dk-amt">' + fmt(k.total) + (k.mrp > k.total ? '<s>' + fmt(k.mrp) + '</s>' : '') + '</div>' +
      '<small>Est. Total</small><button class="dk-tot" id="dk-tot" aria-expanded="' + S.exp + '">View details ' + SVG.chev + '</button></div>' +
      '<button type="button" class="dk-co" id="dk-co" name="checkout"><span class="dk-co__t">Checkout ' + SVG.arrow + '</span>' + payHTML() + '</button></div>' +
      (pe ? '<div class="dk-pp">Get extra ' + lo.pct + '%\u2013' + hi.pct + '% off when you pay online</div>' : '') +
      '<div class="dk-perks">' + perks.map(function (p) { return '<span>' + p + '</span>'; }).join('') + '</div>' +
      '<div class="dk-trust">' + SVG.lock + '<span>100% secure payments \u00B7 UPI, cards & net banking</span></div>';
  }
  window.DKPayErr = function (img) {
    var box = img.closest('.dk-co__pay'); img.parentNode.remove();
    if (box && !box.children.length) box.innerHTML = logosHTML(LOGOS, false);
  };
  function logosHTML(list, custom) {
    return list.map(function (p) {
      return '<i><img src="' + esc(p.src) + '" alt="' + esc(p.alt || '') + '" width="26" height="26" decoding="async"' + (custom ? ' onerror="DKPayErr(this)"' : '') + '></i>';
    }).join('');
  }
  /* payment logos inside the Checkout button: your own uploaded files if set in the snippet, else the built-in ones */
  function payHTML() {
    var own = (CFG.payIcons || []).filter(function (p) { return p && p.src; });
    return '<span class="dk-co__pay" aria-hidden="true">' + (own.length ? logosHTML(own, true) : logosHTML(LOGOS, false)) + '</span>';
  }

  /* Celebrate when the cart reaches a new stage. The last celebrated stage is remembered for the
     browsing session, so it also fires after adding from a product page (new page load).
     Only fires while the drawer is open; dropping below a stage lets it celebrate again later. */
  function checkUnlock() {
    var ok = S.prevOk || 0, seen = 0;
    try { seen = parseInt(sessionStorage.getItem('dk_ok') || '0', 10) || 0; } catch (e) { seen = S.seen || 0; }
    var save = function (v) { S.seen = v; try { sessionStorage.setItem('dk_ok', String(v)); } catch (e) {} };
    if (ok < seen) return save(ok);
    if (ok > seen && el.cart.classList.contains('open')) { save(ok); setTimeout(function () { celebrate(CFG.tiers[ok - 1]); }, 120); }
  }

  /* reward unlocked: ribbons burst up into the air from the progress bar, then flutter down.
     Always plays; with "reduce motion" switched on it uses fewer, slower ribbons. */
  function celebrate(t) {
    if (!t) return;
    var label = t.type === 'ship' ? 'Free shipping' : (t.type === 'gift' && t.name ? t.name : t.label);
    toast('\uD83C\uDF89 ' + label + ' unlocked!');
    var msg = $('.dk-msg', el.cart); if (msg) { msg.classList.remove('dk-win'); void msg.offsetWidth; msg.classList.add('dk-win'); }
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var old = $('.dk-confetti', el.cart); if (old) old.remove();
    var cv = document.createElement('canvas'); cv.className = 'dk-confetti';
    var w = el.cart.clientWidth, h = el.cart.clientHeight, dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); el.cart.appendChild(cv);
    var ctx = cv.getContext('2d');
    var colors = ['#296648', '#3b5bdb', '#d9a23b', '#f06595', '#20c997', '#ffb703', '#8e7cf0'];
    /* launch point: the stage that was just unlocked on the progress bar */
    var cr = el.cart.getBoundingClientRect(), dot = el.cart.querySelectorAll('.dk-st.ok .dk-dotc'), sx = w / 2, sy = 150;
    if (dot.length) { var dr = dot[dot.length - 1].getBoundingClientRect(); sx = dr.left - cr.left + dr.width / 2; sy = dr.top - cr.top + dr.height / 2; }
    var N = calm ? 26 : (w < 400 ? 70 : 90), P = [];
    for (var i = 0; i < N; i++) {
      var ang = -Math.PI / 2 + (Math.random() - 0.5) * 2.2;            // fan out upwards
      var spd = (calm ? 5 : 8) + Math.random() * (calm ? 4 : 8);
      P.push({
        x: sx + (Math.random() - 0.5) * 20, y: sy,
        vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd,
        term: 1.2 + Math.random() * 1.3,                                 // slow fall speed in the air
        sway: 0, swayMax: 0.8 + Math.random() * 1.4, ph: Math.random() * 6.28, sp: 0.05 + Math.random() * 0.05,
        len: 9 + Math.random() * 11, wid: 3 + Math.random() * 2.5,
        rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.18,
        flip: Math.random() * 6.28, vf: 0.1 + Math.random() * 0.12,
        c: colors[i % colors.length]
      });
    }
    var t0 = performance.now(), dur = calm ? 2200 : 3000;
    function frame(now) {
      var k = (now - t0) / dur, a = k < 0.7 ? 1 : Math.max(0, 1 - (k - 0.7) / 0.3);
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.globalAlpha = a;
      for (var j = 0; j < P.length; j++) {
        var p = P[j];
        p.vx *= 0.95;                                                  // air drag
        p.vy = Math.min(p.vy * 0.97 + 0.32, p.term);                   // gravity, capped = floats
        p.sway = Math.min(p.swayMax, p.sway + 0.03);                   // flutter grows once it slows down
        p.ph += p.sp; p.rot += p.vr; p.flip += p.vf;
        p.x += p.vx + Math.sin(p.ph) * p.sway; p.y += p.vy;
        var c = Math.cos(p.rot), s2 = Math.sin(p.rot), f = Math.cos(p.flip);
        ctx.setTransform(c * dpr, s2 * dpr, -s2 * f * dpr, c * f * dpr, p.x * dpr, p.y * dpr);
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.moveTo(-p.wid / 2, -p.len / 2);
        ctx.quadraticCurveTo(p.wid, 0, -p.wid / 2, p.len / 2);
        ctx.lineTo(p.wid / 2, p.len / 2);
        ctx.quadraticCurveTo(p.wid * 2, 0, p.wid / 2, -p.len / 2);
        ctx.closePath(); ctx.fill();
      }
      if (k < 1) requestAnimationFrame(frame); else cv.remove();
    }
    requestAnimationFrame(frame);
  }

  function couponHTML() {
    /* show every valid code on the cart (shopper's own + reward-stage codes); stage codes can't be removed by hand */
    var managed = tierCodes();
    var ok = (S.cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
      var auto = managed.indexOf(d.code.toUpperCase()) > -1;
      return '<div class="dk-cpok"><span>' + SVG.tag + '<span>Code <b>' + esc(d.code.toUpperCase()) + '</b> applied' + (auto ? ' (reward unlocked)' : '') + '</span></span>' +
        (auto ? '' : '<button type="button" data-cprm="' + esc(d.code) + '">Remove</button>') + '</div>';
    }).join('');
    return ok + '<form class="dk-cp" id="dk-cp">' + SVG.tag + '<input id="dk-cpi" placeholder="Enter coupon code" autocomplete="off" aria-label="Coupon code" maxlength="40"><button type="submit">Apply</button></form>';
  }
  function render() {
    var c = S.cart; if (!c) return;
    var k = calc(), n = c.item_count;
    $('#dk-title').innerHTML = 'Your Cart' + (n ? ' <span>' + n + ' item' + (n > 1 ? 's' : '') + '</span>' : '');
    el.banner.textContent = CFG.banner;
    if (!c.items.length) {
      el.body.innerHTML = stepsHTML(k) + '<div class="dk-empty">' + SVG.bag + '<h3>Your cart is empty</h3><p>Add products to unlock free shipping and extra discounts.</p><a class="dk-btn" href="' + R + 'collections/all">Shop all products</a></div>' + upsellHTML();
    } else {
      el.body.innerHTML = stepsHTML(k) + '<div class="dk-items">' + c.items.map(itemHTML).join('') + '</div>' + couponHTML() + upsellHTML();
    }
    el.foot.innerHTML = footHTML(k);
    checkUnlock();
    document.querySelectorAll(CFG.countSelectors).forEach(function (b) { b.textContent = n; });
    syncBubble(n);
  }

  /* Dawn header cart icon: re-render the theme's own "cart-icon-bubble" section so the count
     bubble appears/disappears correctly (Dawn removes the bubble element when the cart is empty). */
  function syncBubble(n) {
    if (S.bubbleCount === n) return; S.bubbleCount = n;
    var icon = document.getElementById('cart-icon-bubble'); if (!icon) return;
    var b = icon.querySelector('.cart-count-bubble');
    if (!n) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + ' item' + (n > 1 ? 's' : '') + '</span>';
  }

  /* ---------- data ---------- */
  function loadHandles(items) {
    var need = {}; items.forEach(function (i) { if (!(i.handle in S.handles)) need[i.handle] = 1; });
    return Promise.all(Object.keys(need).map(function (h) {
      return api(R + 'products/' + h + '.js').then(function (p) { S.handles[h] = p; }).catch(function () { S.handles[h] = null; });
    }));
  }
  function syncGifts() {
    if (S.syncing) return Promise.resolve(false);
    var sub = 0; S.cart.items.forEach(function (i) { if (!isGift(i)) sub += i.original_line_price; });
    var jobs = [];
    CFG.tiers.forEach(function (t) {
      if (t.type !== 'gift' || !t.variantId) return;
      var line = S.cart.items.filter(function (i) { return isGift(i) && i.variant_id === t.variantId; })[0], ok = sub / 100 >= t.at;
      if (ok && !line) jobs.push(api(R + 'cart/add.js', { items: [{ id: t.variantId, quantity: 1, properties: { _free_gift: '1' } }] }).catch(function () {}));
      if (!ok && line) jobs.push(api(R + 'cart/change.js', { id: line.key, quantity: 0 }).catch(function () {}));
    });
    if (!jobs.length) return Promise.resolve(false);
    S.syncing = true;
    return Promise.all(jobs).then(function () { S.syncing = false; return true; });
  }
  /* One place to apply a fresh cart from Shopify. Older responses are ignored (seq), so fast
     clicking can never paint stale numbers. Renders first, then fills compare-at prices if needed. */
  var seq = 0;
  function useCart(c, my) {
    if (my !== undefined && my !== seq) return Promise.resolve();
    if (pendingCount()) { S.cart = c; return Promise.resolve(); }   // a qty change is still queued: wait for it
    S.cart = c;
    return syncGifts().then(function (ch) { return ch ? api(R + 'cart.js').then(function (x) { S.cart = x; }) : 0; })
      .then(syncCodes).then(function (ch) { return ch ? api(R + 'cart.js').then(function (x) { S.cart = x; }) : 0; })
      .then(function () {
        render();
        var need = S.cart.items.some(function (i) { return !(i.handle in S.handles); });
        if (need) loadHandles(S.cart.items).then(function () { if (!pendingCount()) render(); });
        loadUpsell();
      });
  }
  function refresh(quiet) {
    var my = ++seq;
    if (!quiet && S.cart) el.cart.classList.add('dk-busy');
    return api(R + 'cart.js').then(function (c) { return useCart(c, my); })
      .catch(function (e) { toast(e.message); })
      .then(function () { el.cart.classList.remove('dk-busy'); });
  }
  function loadUpsell() {
    var inCart = {}; S.cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var last = S.cart.items.filter(function (i) { return !isGift(i); }).pop(), key = last ? last.product_id : 0;
    if (S.upKey === key && S.up) return; S.upKey = key;
    var norm = function (p) {
      var v = (p.variants || [])[0] || {}, im = p.featured_image && (p.featured_image.url || p.featured_image) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      return { id: p.id, title: p.title, url: R + 'products/' + p.handle, img: im, variants: p.variants || [], vid: v.id, price: toPaise(p.price != null ? p.price : v.price), cmp: toPaise(p.compare_at_price != null ? p.compare_at_price : v.compare_at_price || 0) || 0, ok: p.available !== false && v.available !== false };
    };
    var pick = function (a) { return a.map(norm).filter(function (p) { return p.ok && p.vid && !inCart[p.id]; }).slice(0, 8); };
    var rec = key ? api(R + 'recommendations/products.json?product_id=' + key + '&limit=8&intent=related').then(function (j) { return pick(j.products || []); }).catch(function () { return []; }) : Promise.resolve([]);
    rec.then(function (a) { return a.length ? a : api(R + 'collections/' + CFG.upsellCollection + '/products.json?limit=12').then(function (j) { return pick(j.products || []); }).catch(function () { return []; }); })
      .then(function (a) { S.up = a; var u = $('.dk-up'); if (u) { var t = document.createElement('div'); t.innerHTML = upsellHTML(); u.replaceWith(t.firstChild || document.createTextNode('')); } });
  }

  /* ---------- actions ---------- */
  /* Quantity: update the row instantly, send one request ~300ms after the last click.
     /cart/change.js returns the whole cart, so no second fetch is needed. */
  S.pq = {}; S.pt = {};
  function pendingCount() { return Object.keys(S.pq).length; }
  function lineItem(key) { return S.cart.items.filter(function (i) { return i.key === key; })[0]; }
  function paintLine(key, qty) {
    var it = lineItem(key), row = el.body.querySelector('.dk-li[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (!it || !row) return;
    if (qty <= 0) { row.classList.add('dk-out'); return; }
    var tmp = Object.assign({}, it, { quantity: qty, final_line_price: it.final_price * qty, original_line_price: it.original_price * qty });
    var box = document.createElement('div'); box.innerHTML = itemHTML(tmp);
    row.replaceWith(box.firstChild);
    var bar = $('.dk-bar', el.foot); if (bar) bar.classList.add('dk-pend');
  }
  function change(key, qty) {
    var it = lineItem(key); if (!it) return;
    qty = Math.max(0, qty);
    S.pq[key] = qty; S.pv = S.pv || {}; S.pv[key] = { v: it.variant_id, p: propSig(it) }; paintLine(key, qty);
    clearTimeout(S.pt[key]);
    S.pt[key] = setTimeout(function () { send(key); }, qty === 0 ? 0 : 300);
  }
  /* a line's identity that survives Shopify re-keying it (variant + visible properties) */
  function propSig(i) {
    var p = i.properties || {}, k = Object.keys(p).filter(function (x) { return x.charAt(0) !== '_' || x === '_free_gift'; }).sort();
    return k.map(function (x) { return x + '=' + p[x]; }).join('&');
  }
  /* Shopify can give a line a NEW key when an automatic discount is applied/removed (e.g. crossing
     ₹4,999 or ₹9,999). If our key is rejected, re-read the cart, find the same product and retry once. */
  function postQty(key, qty, retried) {
    return api(R + 'cart/change.js', { id: key, quantity: qty }).catch(function (e) {
      var stale = /no valid id|line parameter|cannot find variant/i.test(e.message || '');
      var ref = S.pv && S.pv[key];
      if (!stale || retried || !ref) throw e;
      return api(R + 'cart.js').then(function (c) {
        var line = c.items.filter(function (i) { return i.variant_id === ref.v && propSig(i) === ref.p; })[0];
        if (!line) return c;                                   // line no longer exists: nothing to update
        if (line.quantity === qty) return c;                   // already at the wanted quantity
        return postQty(line.key, qty, true);
      });
    });
  }
  function send(key) {
    var qty = S.pq[key]; if (qty === undefined) return;
    var my = ++seq;
    postQty(key, qty)
      .then(function (c) {
        if (S.pq[key] === qty) { delete S.pq[key]; if (S.pv) delete S.pv[key]; }   // newer clicks keep it pending
        return useCart(c, pendingCount() ? undefined : my);
      })
      .catch(function (e) {
        delete S.pq[key]; if (S.pv) delete S.pv[key];
        var msg = /no valid id|line parameter/i.test(e.message || '') ? 'Your cart was just updated. Please try again.' : (e.message || 'Could not update quantity');
        toast(msg); return refresh(true);
      });
  }

  function add(variantId, qty, props) {
    el.cart.classList.add('dk-busy');
    return api(R + 'cart/add.js', { items: [{ id: variantId, quantity: qty || 1, properties: props || undefined }] })
      .then(function () { return refresh(true); }).catch(function (e) { toast(e.message); el.cart.classList.remove('dk-busy'); });
  }
  function open(noRefresh) {
    el.cart.inert = false; el.cart.classList.add('open'); el.ov.classList.add('open'); el.cart.setAttribute('aria-hidden', 'false'); root.classList.add('dk-lock');
    S.last = document.activeElement;
    setTimeout(function () { var x = $('.dk-x', el.cart); if (x) { try { x.focus({ preventScroll: true, focusVisible: false }); } catch (e) { x.focus(); } } }, 340);
    if (!noRefresh) refresh(true);
  }
  function close() { el.cart.inert = true; el.cart.classList.remove('open'); el.ov.classList.remove('open'); el.cart.setAttribute('aria-hidden', 'true'); root.classList.remove('dk-lock'); if (S.last && S.last.focus) S.last.focus(); }
  function go() { location.href = R + 'checkout'; } // discount codes already sit on the cart

  /* apply a shopper's coupon to the cart; Shopify decides if it's valid for this cart */
  function applyCoupon(code) {
    el.cart.classList.add('dk-busy');
    var have = cartCodes();
    if (have.indexOf(code) > -1) { el.cart.classList.remove('dk-busy'); return toast('Code ' + code + ' is already applied'); }
    return setCodes(have.concat(code)).then(function (c) {
      S.cart = c;
      if (codeApplicable(code)) { toast('Code ' + code + ' applied'); return refresh(true); }
      toast('Code ' + code + ' isn’t valid for this cart');
      return setCodes(have).then(function () { return refresh(true); });
    }).catch(function () { toast('Couldn’t apply the code. Try again.'); return refresh(true); });
  }
  function removeCoupon(code) {
    el.cart.classList.add('dk-busy');
    var next = cartCodes().filter(function (c) { return c !== code.toUpperCase(); });
    return setCodes(next).then(function () { return refresh(); }).catch(function () { return refresh(true); });
  }

  /* ---------- events ---------- */
  function bind() {
    el.cart.addEventListener('click', function (e) {
      var t = e.target.closest('button,[data-dk-close]'); if (!t) return;
      if (t.hasAttribute('data-dk-close')) return close();
      if (t.dataset.rm) change(t.dataset.rm, 0);
      else if (t.dataset.q) { var it = lineItem(t.dataset.q); if (it) { var cur = S.pq[it.key] !== undefined ? S.pq[it.key] : it.quantity; change(it.key, cur + +t.dataset.d); } }
      else if (t.dataset.add) add(+t.dataset.add, 1);
      else if (t.id === 'dk-tot') { S.exp = !S.exp; t.setAttribute('aria-expanded', S.exp); $('.dk-det').classList.toggle('open', S.exp); }
      else if (t.id === 'dk-co') {
        /* Razorpay Magic Checkout listens for clicks on any [name="checkout"] button and opens its own popup.
           Only fall back to Shopify checkout if Magic Checkout isn't loaded. */
        if (typeof window.openRzpCheckout === 'function') return;
        go();
      }
      else if (t.id === 'dk-nx') { var r = $('#dk-row'); r.scrollBy({ left: r.clientWidth * 0.8, behavior: 'smooth' }); }
      else if (t.dataset.cprm) removeCoupon(t.dataset.cprm);
    });
    el.cart.addEventListener('submit', function (e) {
      if (e.target.id !== 'dk-cp') return; e.preventDefault();
      var v = $('#dk-cpi').value.trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '');
      if (!v) return toast('Enter a coupon code');
      applyCoupon(v);
    });
    el.ov.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.cart.classList.contains('open')) close();
      if (e.key === 'Tab' && el.cart.classList.contains('open')) {
        var f = el.cart.querySelectorAll('a[href],button:not(:disabled),input'); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    /* open from theme cart icons / links */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="/cart"],a[href$="/cart/"],[data-dk-cart-open]');
      if (!a || e.metaKey || e.ctrlKey || a.closest('#dk-cart')) return;
      e.preventDefault(); e.stopPropagation(); open();
    }, true);
    /* ajax add-to-cart from theme product forms */
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.action || f.action.indexOf('/cart/add') < 0) return;
      if (f.dataset.dkSkip) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
      fetch(R + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); }); })
        .then(function () { open(true); return refresh(true); })
        .catch(function (err) { toast(err.message); open(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);
  }

  function init() {
    el.cart = $('#dk-cart'); if (!el.cart) return;
    el.ov = $('#dk-ov'); el.banner = $('#dk-banner'); el.body = $('#dk-body'); el.foot = $('#dk-foot'); el.toast = $('#dk-toast');
    el.cart.inert = true;
    bind();
    window.DKCart = { open: open, close: close, refresh: refresh, add: add };

    /* /cart page is disabled: theme.liquid redirects it here with ?cart=open, so open the drawer and clean the URL */
    var qs = new URLSearchParams(location.search);
    if (qs.get('cart') === 'open') {
      qs.delete('cart');
      try { history.replaceState(null, '', location.pathname + (qs.toString() ? '?' + qs : '') + location.hash); } catch (x) {}
      open();
      return;
    }
    refresh(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();